import React, {useState} from "react";
import Panel from "../unfox-design/Panel";
import Header from "../unfox-design/Header";
import Group from "../unfox-design/Group";
import Input from "../unfox-design/Input";
import Title from "../unfox-design/Title";
import Button from "../unfox-design/Button";
import CardGrid from "../unfox-design/CardGrid";
import Card from "../unfox-design/Card";
import Select from "../unfox-design/Select";
import Slider from "../unfox-design/Slider";
import {Checkbox} from "@vkontakte/vkui";
import API from "../../API";
import Snackbar from "../unfox-design/Snackbar";
import {TITLE} from "../../config";
import Placeholder from "../unfox-design/Placeholder";

class Configuration extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loadedData: false,
            range: 0,
            fov: 0,
            hwid: '',
            snackbar: false,
            snackText: '',
            testModule: [],
            modulesState: [],
            disableHWID: false,
            userInfo: {},
            defaultConfig: [],
        }
    }

    JsonToElements = (inItems) => {
        let elementIndex = 0;
        let ConfigurationData = '';
        let modulesState = this.state.modulesState;
        let returnItems = inItems['response'].map(dt => {
            let data = JSON.parse(dt.string);
            let items = data.items.map(item => {
                let element = 'Неизвестно';
                const index = elementIndex;

                let selected = item.selected;

                if (!this.state.loadedData && this.state.ConfigurationArray[index] !== undefined) {
                    modulesState[index] = this.state.ConfigurationArray[index];
                    selected = this.state.ConfigurationArray[index];
                    this.setState({modulesState});
                } else {
                    if (modulesState[index] === undefined) {
                        modulesState[index] = item.selected;
                        selected = item.selected;
                        this.setState({modulesState});
                    }
                }
                switch (item.type) {
                    case 'select':
                        element =
                            <Select
                                title={item.title}
                                items={item.values.split(',')}
                                selected={selected}
                                onChange={(value) => {
                                    let modulesState = this.state.modulesState;
                                    modulesState[index] = value;
                                    this.setState({modulesState});
                                    this.setState({testModule: this.JsonToElements(inItems)});

                                }}
                            />;
                        break;

                    case 'slider':
                        element =
                            <div>
                                {item.title} ({this.state.modulesState[index] || 0})
                                <Slider {...item.args} value={this.state.modulesState[index]} onChange={(e) => {
                                    let modulesState = this.state.modulesState;
                                    modulesState[index] = e.target.value;
                                    this.setState({modulesState});
                                    this.setState({testModule: this.JsonToElements(inItems)});
                                }}/>
                            </div>
                        break;

                    case 'checkbox':
                        element = <Checkbox checked={this.state.modulesState[index]} onChange={(e) => {
                            let modulesState = this.state.modulesState;
                            modulesState[index] = e.target.checked;
                            this.setState({modulesState});
                            this.setState({testModule: this.JsonToElements(inItems)});
                        }}>{item.title}</Checkbox>
                        break;
                }
                elementIndex += 1;
                return element;
            });
            if (dt.disabled != "true") {
                return <div className="CardTest">
                    <Title>{data.title}</Title>
                    {items}
                </div>
            }
        });
        this.props.showLoaderFull();
        this.setState({loadedData: true});
        if (this.state.ConfigurationArray.length < 1) {
            this.saveModules(this.state.modulesState, false);
        }
        return returnItems;
    }

    async componentDidMount() {
        let userInfo = JSON.parse(localStorage.userInfo);
        this.setState({userInfo});

        if (this.props.hwid && this.props.hwid.length > 2) {
            this.setState({disableHWID: true});
        }
        this.props.showLoaderFull(true);
        let defaultModules = await API.execute('getDefaultModules');
        this.setState({defaultConfig: defaultModules});
        let ConfigurationData = await API.execute('getConfiguration');
        let ConfigurationArray = [];
        if (ConfigurationData['response']) {
            ConfigurationArray = JSON.parse(ConfigurationData['response'])
        }
        this.setState({ConfigurationArray});
        this.setState({testModule: this.JsonToElements(this.state.defaultConfig)})
    }

    showSnack = (e, text) => {
        this.setState({snackText: text});
        this.setState({snackbar: e});
    }

    saveHWID = () => {
        API.execute('setHWID', {hwid: this.state.hwid}).then(data => {
            this.showSnack(true, `😁 ${data.response}`);
            this.setState({disableHWID: true});
        }).catch(error => {
            const errorMessage = error.error ? error.error['error_message'] : error;
            this.showSnack(true, `🤔 ${errorMessage}`);
        });
    };


    saveModules = (config, showSnack = true) => {
        API.execute('updateConfiguration', {config: JSON.stringify(config)}).then(data => {
            if (showSnack) {
                this.showSnack(true, `😁 ${data.response}`);
            }
        }).catch(error => {
            const errorMessage = error.error ? error.error['error_message'] : error;
            this.showSnack(true, `🤔 ${errorMessage}`);
        });
    };

    render() {
        return (

            <Panel>
                <Header status={TITLE}>
                    Configuration
                </Header>
                {
                    !this.state.disableHWID && this.state.userInfo.status === 'premium' ?
                        <Group>
                            <Input disabled={this.state.disableHWID} placeholder="Your HWID" value={this.props.hwid}
                                   onChange={(e) => {
                                       this.props.updateHwid(e.target.value.trim());
                                       this.setState({hwid: e.target.value.trim()})
                                   }}/>
                            {!this.state.disableHWID ? <Button size="l" onClick={this.saveHWID}>Save</Button> : ''}
                        </Group>
                        : null
                }
                {this.state.userInfo.status === 'premium' ?
                    <div>
                        {this.state.disableHWID ?
                            <Group>
                                <Title>
                                    Modules
                                </Title>
                                <CardGrid>
                                    {
                                        this.state.testModule
                                    }
                                </CardGrid>
                                <Button size="l" onClick={() => this.saveModules(this.state.modulesState)}>
                                    Save
                                </Button>
                            </Group> : <Placeholder title={'Error'}>
                                <div>Set up your HWID!</div>
                            </Placeholder>}
                    </div> : <Placeholder title={'Not enough rights'}>
                        <div>Only for premiums!</div>
                    </Placeholder>}
                <Snackbar start={this.state.snackbar} callback={() => {
                    this.setState({snackbar: false})
                }} vertical="bottom" duration={3000}>
                    {this.state.snackText}
                </Snackbar>
            </Panel>
        )
    }
};
export default Configuration;
